import { styled } from '@mui/material/styles';
export const Card = styled('div')(({ theme }) => ({
    cursor: 'pointer',
    fontSize: '0.7rem',
    position: 'relative',
    margin: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}));
